// extracted by mini-css-extract-plugin
module.exports = {"grid":"EntityDefinition_grid__26RiG"};